module.exports = __webpack_public_path__ + "img/menu_logout.2b29da1a.svg";